/**
 * Client-side offer status helpers (mirrors server logic for badges/UI).
 */

export const OFFER_STATUS_STYLES = {
  active: { label: 'Active', color: '#10b981', bg: '#d1fae5', textColor: '#065f46' },
  scheduled: { label: 'Scheduled', color: '#3b82f6', bg: '#dbeafe', textColor: '#1e40af' },
  expired: { label: 'Expired', color: '#ef4444', bg: '#fee2e2', textColor: '#991b1b' },
  draft: { label: 'Draft', color: '#6b7280', bg: '#f3f4f6', textColor: '#374151' },
};

export const startOfDay = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const endOfDay = (date) => {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
};

export const computeOfferStatus = ({ startDate, endDate, status }, now = new Date()) => {
  if (status === 'draft') return 'draft';
  if (!startDate || !endDate) return 'draft';
  const start = startOfDay(startDate);
  const end = endOfDay(endDate);
  const ts = now.getTime();
  if (ts < start.getTime()) return 'scheduled';
  if (ts > end.getTime()) return 'expired';
  return 'active';
};

/** Whether a property discount should show to guests. */
export const isDiscountVisibleToGuest = (discount) => {
  if (!discount || !discount.isActive || !(discount.value > 0)) return false;
  const status = discount.status || 'active';
  if (status !== 'active') return false;
  const from = discount.validFrom;
  const until = discount.validUntil;
  if (from && until) {
    return computeOfferStatus(
      { startDate: from, endDate: until, status: status === 'draft' ? 'draft' : undefined }
    ) === 'active';
  }
  return true;
};

export const getOfferStatusStyle = (status) =>
  OFFER_STATUS_STYLES[status] || OFFER_STATUS_STYLES.draft;

export const validateOfferDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return { valid: false, message: 'Start and end dates are required for an offer.' };
  }
  if (endOfDay(endDate).getTime() <= startOfDay(startDate).getTime()) {
    return { valid: false, message: 'End date must be after start date.' };
  }
  return { valid: true };
};

export const resolveDiscountStatus = (discount) => {
  if (!discount) return 'draft';
  if (discount.status) return discount.status;
  if (!discount.isActive) return 'draft';
  if (discount.validFrom && discount.validUntil) {
    return computeOfferStatus({
      startDate: discount.validFrom,
      endDate: discount.validUntil,
    });
  }
  return discount.isActive ? 'active' : 'draft';
};
